import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelSelect as _vModelSelect, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { class: "st_myreg_customize_form" }
const _hoisted_5 = { class: "st_myreg_form" }
const _hoisted_6 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_7 = { class: "st_myreg_agree_wrap st_myreg_mgt" }
const _hoisted_8 = { class: "st_myreg_agree" }
const _hoisted_9 = { class: "agree_check_box" }
const _hoisted_10 = { class: "st_myreg_btn_wrap" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "success-message",
  style: {"color":"blue","margin-top":"10px","text-align":"center"}
}

import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env"; // Firebase Callable Function
import type { Myreg } from "@/model/myreg"; // Myreg 모델 임포트
import { useAlertDialog } from "@/composables/useAlert";
import * as common from "@/assets/common/common";

import { NButton, NUpload } from "naive-ui";

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const useAlert = useAlertDialog();
const router = useRouter();
const uploadAttachmentCallable = getCallable("uploadAttachment");

const initialFormData: Myreg = {
  name: "",
  phone1: "",
  phone2: "",
  phone3: "",
  email: "",
  content: "",
  attached_file_name: "",
  attached_file_drive_id: "",
  privacyAgreement: "", // 'agree' 또는 'disagree'
};

const myregFormData = ref<Myreg>({ ...initialFormData });
const selectedFile = ref<File | null>(null);
const isLoading = ref<boolean>(false);
const successMessage = ref<string | null>(null);
const uploadedFileId = ref<string | null>(null); // 업로드된 파일 ID 저장
const uploadedFileName = ref<string | null>(null); // 업로드된 파일 이름 표시용

async function handleUploadChange(options: {
  file: { file: File | null; status: string };
  fileList: Array<{ file: File | null; status: string }>;
}) {
  const { file } = options;
  if (file.file && file.status !== "removed") {
    uploadedFileName.value = file.file.name; // 파일 이름 표시
    await handleFileUpload(file.file);
  } else if (file.status === "removed") {
    uploadedFileName.value = null;
    uploadedFileId.value = null; // 파일 제거 시 ID도 초기화
  }
}

async function handleFileUpload(file) {
  if (!file) return;
  isLoading.value = true; // 로딩 시작
  const reader = new FileReader();
  reader.readAsDataURL(file); // 파일을 Base64로 읽음
  reader.onload = async () => {
    const base64String = (reader.result as string).split(",")[1]; // 'data:mime/type;base64,' 부분 제거
    try {
      const result = await uploadAttachmentCallable({
        file: {
          base64: base64String,
          name: file.name,
          type: file.type,
        },
      });
      if (common.evalFunctionResult(result)) {
        const fileId = common.getItemFromFunctionResult(result);
        uploadedFileId.value = fileId;
      } else {
        isLoading.value = false; // 로딩 종료
        await useAlert(
          common.getResultError(result) || "파일 업로드 중 오류 발생"
        );
      }
    } catch (error) {
      uploadedFileName.value = null; // 실패 시 파일 이름 표시 제거
      console.error("Error uploading file:", error);
      isLoading.value = false; // 로딩 종료
      await useAlert(error.message || "파일 업로드 중 심각한 오류 발생");
    } finally {
      isLoading.value = false; // 로딩 종료
    }
  };
  reader.onerror = (error) => {
    console.error("Error reading file:", error);
  };
}
const addMyreg = getCallable("addMyreg");

const submitInquiry = async () => {
  successMessage.value = null;

  // 유효성 검사 (간단한 예시)
  if (
    !myregFormData.value.name ||
    !myregFormData.value.phone1 ||
    !myregFormData.value.phone2 ||
    !myregFormData.value.phone3 ||
    !myregFormData.value.email ||
    !myregFormData.value.content
  ) {
    await useAlert("필수 입력 항목을 모두 채워주세요.");
    return;
  }
  if (myregFormData.value.privacyAgreement !== "agree") {
    await useAlert("개인정보 수집·이용에 동의해주세요.");
    return;
  }

  isLoading.value = true;

  try {
    const phoneNumber = `${myregFormData.value.phone1}-${myregFormData.value.phone2}-${myregFormData.value.phone3}`;
    myregFormData.value.phoneNumber = phoneNumber;
    myregFormData.value.attached_file_name = uploadedFileName.value;
    myregFormData.value.attached_file_drive_id = uploadedFileId.value; // 첨부파일 ID 추가

    const result: any = await addMyreg(myregFormData.value);

    if (result.data && result.data.error) {
      throw new Error(result.data.message || "문의 등록에 실패했습니다.");
    }

    myregFormData.value = { ...initialFormData }; // 폼 초기화
    selectedFile.value = null;
    const fileInput = document.getElementById("s_v4") as HTMLInputElement;
    if (fileInput) fileInput.value = ""; // 파일 입력 필드 초기화

    isLoading.value = false;
    await useAlert("문의가 성공적으로 등록되었습니다.");

    // 선택적으로 다른 페이지로 리디렉션
    // router.push(`${USER_ROUTES.Inquiry.Path}`);
  } catch (error: any) {
    console.error("Error submitting inquiry:", error);
    await useAlert(
      error.message ||
        "문의 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
    );
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "etc",
      subtitle: "etc",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Sidebar),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(Loading, null, null, 512), [
          [_vShow, isLoading.value]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("문의하기"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            name: "myreg_form",
            onSubmit: _withModifiers(submitInquiry, ["prevent"]),
            ENCTYPE: "multipart/form-data",
            style: {"margin":"0"}
          }, [
            _cache[24] || (_cache[24] = _createStaticVNode("<input type=\"hidden\" name=\"tmp_name\" value=\"tmp_val\" data-v-776fda58><input type=\"hidden\" name=\"this_domain\" data-v-776fda58><input type=\"hidden\" name=\"post_action\" data-v-776fda58><input type=\"hidden\" name=\"bu_id\" value=\"\" data-v-776fda58><input type=\"hidden\" name=\"y\" data-v-776fda58><input type=\"hidden\" name=\"idx\" data-v-776fda58><input type=\"hidden\" name=\"me_popup\" data-v-776fda58><input type=\"hidden\" name=\"mode\" data-v-776fda58><input type=\"hidden\" name=\"myreg_code\" value=\"reg_01\" data-v-776fda58><input type=\"hidden\" name=\"user_app_subject\" value=\"\" data-v-776fda58><input type=\"hidden\" name=\"user_app_goods_name\" value=\"\" data-v-776fda58><input type=\"hidden\" name=\"user_app_price\" value=\"\" data-v-776fda58><input type=\"hidden\" name=\"captcha_str_hash\" value=\"\" data-v-776fda58><input type=\"hidden\" name=\"recaptcha_form_yn\" value=\"0\" data-v-776fda58><input type=\"hidden\" name=\"form_sess_id\" value=\"716vsn2hkvktapfcokmmb69lg7\" data-v-776fda58><input type=\"hidden\" name=\"use_emoney_ok\" id=\"use_emoney_ok\" value=\"0\" data-v-776fda58><input type=\"hidden\" name=\"s_t30\" id=\"nicednb_enc_str\" value=\"\" data-v-776fda58>", 17)),
            _createElementVNode("table", _hoisted_5, [
              _cache[17] || (_cache[17] = _createElementVNode("caption", null, " 기본정보 ", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("colgroup", null, [
                _createElementVNode("col", { style: {"width":"250px"} }),
                _createElementVNode("col")
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, [
                    _createTextVNode("이 름 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v1",
                      id: "s_v1",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((myregFormData.value.name) = $event))
                    }, null, 512), [
                      [_vModelText, myregFormData.value.name]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("th", null, [
                    _createTextVNode("핸드폰 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      name: "s_v2_hp1",
                      style: {"width":"55px"},
                      title: "휴대전화 첫번째",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((myregFormData.value.phone1) = $event))
                    }, _cache[9] || (_cache[9] = [
                      _createStaticVNode("<option value=\"\" data-v-776fda58>선택</option><option value=\"010\" data-v-776fda58>010</option><option value=\"011\" data-v-776fda58>011</option><option value=\"016\" data-v-776fda58>016</option><option value=\"017\" data-v-776fda58>017</option><option value=\"018\" data-v-776fda58>018</option><option value=\"019\" data-v-776fda58>019</option>", 7)
                    ]), 512), [
                      [_vModelSelect, myregFormData.value.phone1]
                    ]),
                    _cache[10] || (_cache[10] = _createTextVNode(" - ")),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v2_hp2",
                      size: "4",
                      maxlength: "4",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((myregFormData.value.phone2) = $event)),
                      value: "",
                      title: "휴대전화 두번째"
                    }, null, 512), [
                      [_vModelText, myregFormData.value.phone2]
                    ]),
                    _cache[11] || (_cache[11] = _createTextVNode(" - ")),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v2_hp3",
                      size: "4",
                      maxlength: "4",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((myregFormData.value.phone3) = $event)),
                      value: "",
                      title: "휴대전화 세번째"
                    }, null, 512), [
                      [_vModelText, myregFormData.value.phone3]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", null, [
                    _createTextVNode("이메일 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "s_v3",
                      id: "s_v3",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((myregFormData.value.email) = $event)),
                      value: ""
                    }, null, 512), [
                      [_vModelText, myregFormData.value.email]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("th", null, [
                    _createTextVNode("내 용 "),
                    _createElementVNode("span", { class: "st_myreg_required" }, "*")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "s_t1",
                      id: "s_t1",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((myregFormData.value.content) = $event)),
                      style: {"width":"100%","height":"150px"}
                    }, null, 512), [
                      [_vModelText, myregFormData.value.content]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("th", null, "파일첨부", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(_unref(NUpload), {
                      action: "#",
                      "default-upload": false,
                      onChange: handleUploadChange,
                      max: 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NButton), null, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("파일 선택")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (uploadedFileName.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 선택된 파일: " + _toDisplayString(uploadedFileName.value), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "st_myreg_title" }, "개인정보 수집·이용 동의", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"st_myreg_agree_box\" data-v-776fda58><h5 data-v-776fda58>수집하는 개인정보의 항목</h5><p data-v-776fda58> 회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은 개인정보를 수집하고 있습니다. </p><ul data-v-776fda58><li data-v-776fda58>수집항목 : 이 름, 핸드폰, 이메일, 내 용, 파일첨부</li><li data-v-776fda58>개인정보 수집방법 : <span data-v-776fda58>홈페이지</span></li></ul><h5 data-v-776fda58>개인정보의 수집 및 이용목적</h5><p data-v-776fda58>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p><ul data-v-776fda58><li data-v-776fda58>연락 및 상담<br data-v-776fda58></li></ul><h5 data-v-776fda58>개인정보의 보유 및 이용기간</h5><p data-v-776fda58> 회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를 지체 없이 파기합니다. </p></div>", 1)),
                _createElementVNode("div", _hoisted_9, [
                  _cache[21] || (_cache[21] = _createElementVNode("input", {
                    type: "checkbox",
                    name: "myreg_privacy_chk",
                    id: "myreg_privacy_chk",
                    value: "1"
                  }, null, -1)),
                  _createElementVNode("span", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "myreg_privacy_radio",
                      id: "myreg_privacy_radio_agree",
                      value: "agree",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((myregFormData.value.privacyAgreement) = $event))
                    }, null, 512), [
                      [_vModelRadio, myregFormData.value.privacyAgreement]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("label", { for: "myreg_privacy_radio_agree" }, "개인정보 수집·이용에 동의합니다.", -1))
                  ]),
                  _createElementVNode("span", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "myreg_privacy_radio",
                      id: "myreg_privacy_radio_disagree",
                      value: "disagree",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((myregFormData.value.privacyAgreement) = $event))
                    }, null, 512), [
                      [_vModelRadio, myregFormData.value.privacyAgreement]
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("label", { for: "myreg_privacy_radio1" }, "개인정보 수집·이용에 동의하지 않습니다.", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "submit",
                class: "st_myreg_btn_type1 st_myreg_highlight",
                disabled: isLoading.value
              }, _toDisplayString(isLoading.value ? "처리 중..." : "확 인"), 9, _hoisted_11)
            ]),
            (successMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(successMessage.value), 1))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}
}

})